import { Navigate } from "react-router-dom";
import { useAuth } from "../Components/Auth/AuthProvider";

function AuthGuard({ children }) {
  const { isLoggedIn } = useAuth();
  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }
  return children;
}

export default AuthGuard;